export const PARTNERS_TYPE = {
  PERSONAL: 'PERSONAL',
  BUSINESS: 'BUSINESS',
} as const;
